import { AppSectionKey, IAppSection } from './app-section.model';

export interface AppSectionRegistryItem {
  sectionKey: AppSectionKey;
  routeNames: string[];
  navigateKey?: string;
  showInSideMenu?: boolean;
  showInBottomTab?: boolean;
}

export const DEFAULT_APP_SECTIONS: IAppSection[] = [
  { sectionKey: 'SHOWCASE', name: 'Главная', availableToAll: true, sortOrder: 10 },
  { sectionKey: 'PROGRAMS', name: 'Релизы от Лиги', availableToAll: true, sortOrder: 20 },
  { sectionKey: 'PLAYLIST_LIST', name: 'Миксы', availableToAll: true, sortOrder: 30 },
  { sectionKey: 'MUSIC_LIBRARY', name: 'Музыка', availableToAll: false, roleName: 'ROLE_MUSIC_LIBRARY', sortOrder: 40 },
  { sectionKey: 'TRAININGS', name: 'Тренинги', availableToAll: false, roleName: 'ROLE_TRAININGS', sortOrder: 50 },
  { sectionKey: 'EXERCISES', name: 'Упражнения', availableToAll: false, roleName: 'ROLE_EXERCISES', sortOrder: 60 },
  { sectionKey: 'WORKOUTS', name: 'Тренировки', availableToAll: false, roleName: 'ROLE_WORKOUTS', sortOrder: 70 },
  { sectionKey: 'EDUCATION', name: 'Образование', availableToAll: false, roleName: 'ROLE_EDUCATION', sortOrder: 80 },
  { sectionKey: 'TESTING', name: 'Тестирование', availableToAll: true, sortOrder: 90 },
  { sectionKey: 'EVENTS', name: 'События', availableToAll: true, sortOrder: 100 },
  { sectionKey: 'SUBSCRIPTIONS', name: 'Подписки', availableToAll: true, sortOrder: 105 },
  { sectionKey: 'USEFUL_LINKS', name: 'Полезные ссылки', availableToAll: false, roleName: 'ROLE_USEFUL_LINKS', sortOrder: 110 },
  { sectionKey: 'MY_TICKETS', name: 'Мои билеты', availableToAll: true, sortOrder: 120 },
  { sectionKey: 'MY_SUBSCRIPTIONS', name: 'Мои подписки', availableToAll: true, sortOrder: 125 },
  { sectionKey: 'SUPPORT', name: 'Техподдержка', availableToAll: true, sortOrder: 130 },
  { sectionKey: 'SETTINGS', name: 'Настройки', availableToAll: true, sortOrder: 140 },
  { sectionKey: 'ACCOUNT', name: 'Аккаунт', availableToAll: true, sortOrder: 150 },
];

export const APP_SECTION_REGISTRY: AppSectionRegistryItem[] = [
  { sectionKey: 'SHOWCASE', routeNames: ['Showcase'], navigateKey: 'showcase', showInSideMenu: true, showInBottomTab: true },
  {
    sectionKey: 'PROGRAMS',
    routeNames: ['Programs', 'ProgramReleases', 'ReleasePage', 'ReleaseMain', 'ReleaseGuide', 'ReleaseVideo', 'ReleaseMusic'],
    navigateKey: 'programs',
    showInSideMenu: true,
    showInBottomTab: true,
  },
  {
    sectionKey: 'PLAYLIST_LIST',
    routeNames: ['PlaylistList', 'PlayListView'],
    navigateKey: 'playlist-list',
    showInSideMenu: true,
    showInBottomTab: true,
  },
  {
    sectionKey: 'MUSIC_LIBRARY',
    routeNames: ['MusicLibrary', 'MusicLibraryFolder'],
    navigateKey: 'music-library',
    showInSideMenu: true,
    showInBottomTab: true,
  },
  { sectionKey: 'TRAININGS', routeNames: ['Skills'], navigateKey: 'skills', showInSideMenu: true },
  { sectionKey: 'EXERCISES', routeNames: ['Exercises'], navigateKey: 'exercises', showInSideMenu: true },
  { sectionKey: 'WORKOUTS', routeNames: ['Workouts'], navigateKey: 'workouts', showInSideMenu: true },
  { sectionKey: 'EDUCATION', routeNames: ['Education'], navigateKey: 'education', showInSideMenu: true },
  { sectionKey: 'TESTING', routeNames: ['Testing'], navigateKey: 'testing', showInSideMenu: true },
  { sectionKey: 'EVENTS', routeNames: ['EventsList', 'EventDetail', 'EventPaymentSuccess'], navigateKey: 'events', showInSideMenu: true },
  {
    sectionKey: 'SUBSCRIPTIONS',
    routeNames: ['SubscriptionDetail'],
    navigateKey: 'subscriptions',
    showInSideMenu: false,
  },
  { sectionKey: 'USEFUL_LINKS', routeNames: ['UsefulLinks'], navigateKey: 'useful-links', showInSideMenu: true },
  { sectionKey: 'MY_TICKETS', routeNames: ['MyTickets'], navigateKey: 'my-tickets', showInSideMenu: true },
  { sectionKey: 'MY_SUBSCRIPTIONS', routeNames: ['MySubscriptions'], navigateKey: 'my-subscriptions', showInSideMenu: true },
  { sectionKey: 'SUPPORT', routeNames: [], showInSideMenu: true },
  { sectionKey: 'SETTINGS', routeNames: ['Settings'], navigateKey: 'settings', showInSideMenu: true },
  { sectionKey: 'ACCOUNT', routeNames: ['Account', 'ChangePassword'], navigateKey: 'account', showInSideMenu: true },
];

export const APP_SECTION_BY_ROUTE_NAME = APP_SECTION_REGISTRY.reduce<Record<string, AppSectionKey>>((acc, item) => {
  item.routeNames.forEach(routeName => {
    acc[routeName] = item.sectionKey;
  });
  return acc;
}, {});

export function appSectionKeyByRouteName(routeName?: string | null): AppSectionKey | undefined {
  return routeName ? APP_SECTION_BY_ROUTE_NAME[routeName] : undefined;
}
